import { createContext, useContext } from "react"

const MemberApplyPathContext = createContext(false)

export const MemberApplyPathProvider = MemberApplyPathContext.Provider

/** True when the dashboard replaces the Path to Membership widget with the apply action. */
export const useReplacePathWithApply = () => useContext(MemberApplyPathContext)
